import React from 'react'
import {FaBars} from 'react-icons/fa'
import { ShoppingCart } from '@material-ui/icons'
import { Nav, NavbarContainer, NavLogo, MobileIcon, NavItem, NavLinks, NavMenu } from './style';
import { IconButton, Badge, Typography } from '@material-ui/core';  
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({ toggle, totalItems, refFooter, refAbout, refHome, refMetod }) => {

    function showFooter() {
        window.scrollTo({
          top: refFooter.current.offsetTop - 30,
          behavior: "smooth"
        })
      }
      function showAbout() {
        window.scrollTo({
          top: refAbout.current.offsetTop - 30,
          behavior: "smooth"
        })
      }

      function showHome() {
        window.scrollTo({
          top: refHome.current.offsetTop - 30,
          behavior: "smooth"
        })
      }

      function showMetod() {
        window.scrollTo({
          top: refMetod.current.offsetTop - 30,
          behavior: "smooth"
        })
      }

    const location = useLocation();

    return (
        <>
          <Nav>
              <NavbarContainer>
                  <NavLogo to='/'>MyLogo</NavLogo>
                  <MobileIcon onClick={ toggle }>
                        <Badge badgeContent={totalItems} color="error">
                        <FaBars />
                        </Badge>
                  </MobileIcon>
                  <NavMenu>
                      <NavItem>
                          <NavLinks><Typography onClick={showHome}>Beranda</Typography></NavLinks>
                      </NavItem>
                      <NavItem>
                          <NavLinks><Typography onClick={showAbout}>Tentang Kami</Typography></NavLinks>
                      </NavItem>
                      <NavItem>
                          <NavLinks><Typography onClick={showMetod}>Cara Pembelian</Typography></NavLinks>
                      </NavItem>
                      <NavItem>
                          <NavLinks><Typography onClick={showFooter}>Kontak Kami</Typography></NavLinks>
                      </NavItem>
                      <NavItem>
                          <NavLinks>
                          {location.pathname === '/' && (
                            <div>
                                <IconButton component={Link} to="/cart" color="inherit">
                                    <Badge badgeContent={totalItems} color="error">
                                        <ShoppingCart />
                                    </Badge>
                                </IconButton>
                            </div>
                        )}
                          </NavLinks>
                      </NavItem>
                  </NavMenu>
              </NavbarContainer>
          </Nav>  
        </>
    )
}

export default Navbar;